import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTWCL_If_you_have_not_completed_veri_ELL,
  TXTWCL_To_find_out_moreX_visit_our_Xa_ELL
} from './HelpSectionContent.messages.json';

const HelpSectionContent: React.FC = () => (
  <>
    <Translation {...TXTWCL_If_you_have_not_completed_veri_ELL} />{' '}
    <Translation
      values={{
        a: (msg: React.ReactNode) => (
          <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
        )
      }}
      {...TXTWCL_To_find_out_moreX_visit_our_Xa_ELL}
    />
  </>
);

export default HelpSectionContent;
